// evo/rooms/EvoKidsStayFreeBadge.tsx
// Green "success" pill shown at the top of a room card (right below the room name) when any of the
// room's rates carries a CHILDREN_FREE_OFFER promotion. Mirrors EvoRoomAvailabilityAlertLabel, using
// the success tokens instead of warning. This replaces the former line-item rendering of this
// promotion (see EvoRoomPromotions), matching the DP-evolution Figma. When the promotion carries a
// description, an info icon exposes it via a tooltip that opens on hover, keyboard focus AND tap.
import styled from 'styled-components';
import { Text } from '@lmn/design-system';
import { useTranslation } from '@/app/components/translations/Translation';
import { InfoTooltipButton } from '@/app/components/hotel-detail/common/InfoTooltipButton';

const SuccessPill = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.kallisto.space.space50};
  padding: ${({ theme }) => theme.kallisto.space.space50} ${({ theme }) => theme.kallisto.space.space100};
  background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundSuccessSubtle};
  border-radius: ${({ theme }) => theme.kallisto.border.radius.radius50};
  border: 1px solid ${({ theme }) => theme.kallisto.color.border.static.borderSuccessSubtle};
`;

export function EvoKidsStayFreeBadge({ description }: { description?: string }) {
  const { t } = useTranslation();
  const label = t('vacation.oss.cards.badgets.childrenstayfree');

  return (
    <SuccessPill>
      <Text variant="BodySmall" color="textSuccess">
        {label}
      </Text>
      {description && <InfoTooltipButton content={description} iconColor="iconSuccess" aria-label={label} />}
    </SuccessPill>
  );
}
